<template>
    <v-dialog
            v-model="isOpen"
            max-width="1200"
        >
            <v-card>
                <v-card-title class="headline pb-10">
                    Выберите пользователей
                </v-card-title>
                <v-card-text>
                    <v-app>
                        <v-content>
                            <UserTable></UserTable>
                        </v-content>
                    </v-app>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <b-button type="is-default" @click="close()">Закрыть</b-button>
                    <b-button type="is-primary" :disabled="isSending" @click="send()"
                        >Создать</b-button
                    >
                </v-card-actions>
            </v-card>
    </v-dialog>
</template>

<script>
import UserTable from "@/app/admin/users/shared/components/userTable";

export default {
    name: "CreateNotifications",
    components: {
        UserTable,
    },
    props: [
        'params'
    ],
    data() {
        return {
            isSending: false,
        };
    },
    computed: {
        isOpen: {
            get() {
                return this.$store.getters.IS_USER_MODALS_OPENED;
            },
            set() {
                this.$store.dispatch('USER_MODALS', false);
            }
        },
        filters() {
            return this.$store.getters.GET_USERS_FILTERS;
        },
        defaultFilters() {
            return this.$store.getters.GET_DEFAULT_USER_FILTERS;
        },
    },
    created() {
        switch (this.channel) {
            case "sms":
                this.defaultFilters.approved_phone = 0;
                this.defaultFilters.approved_email = 0;
                break;
            case "email":
        this.defaultFilters.approved_phone = 0;
        this.defaultFilters.approved_email = 0;
        break;
      default:
        this.defaultFilters.approved_phone = 0;
        this.defaultFilters.approved_email = 0;
    }
  },
  methods: {
    close() {
        this.$store.dispatch('USER_MODALS', false);
    },
    send() {
      const params = {
        type: this.params.channel,
        settings: this.params.settings,
        filters: this.filters,
      };
      params.settings.planned_at = params.settings.planned_at.getTime();
      this.isSending = true;
      let diff = new Date().getTimezoneOffset();
      if (params.filters.registerDate.from) {
        let some_date = new Date(params.filters.registerDate.from);
        some_date.setMinutes(some_date.getMinutes() + diff);
        params.filters.registerDate.from = some_date;
      }
      if (params.filters.registerDate.to) {
        let some_date = new Date(params.filters.registerDate.to);
        some_date.setMinutes(some_date.getMinutes() + diff);
        params.filters.registerDate.to = some_date;
      }
      this.$store.dispatch("SEND_INSTANT_NOTIFICATIONS", params)
        .then(() => {
            this.$toaster.success("Уведомления поставлены на отправку в фоновом режиме");
            this.$store.dispatch('USER_MODALS', false);
        })
        .catch(() => {
            this.$toaster.error("Ошибка при создании уведомлений");
        })
        .finally(() => {
            this.$emit("close");
        });
        },
    },
};
</script>

<style></style>
